import { Form as FactorialForm } from 'factorial-form'

class WorkScheduleNameForm extends FactorialForm {
  constructor(values: object) {
    super(values, {
      name: 'string',
    })
  }
}

export default WorkScheduleNameForm
